import { all, takeLatest, fork, put, select } from 'redux-saga/effects';
import DishCategoriesApi from 'libs/api/dish_categories';
import routeCodes from 'common/constants/route-codes';
import UIHelper from 'services/UIHelper';
import * as types from './types';
import { setModalData } from '../common/actions';
import {
  DISH_CATEGORY_DELETE_REQUEST,
  DISH_CATEGORY_GET_REQUEST,
} from './types';

function* getDishCategories({ payload }) {
  try {
    const currentRestaurant = yield select((s) => s.common.currentRestaurant);
    const api = new DishCategoriesApi(currentRestaurant?.id);

    const { data } = yield api.list({
      params: {
        per: 10000,
      }
    });
    yield put({
      type: types.DISH_CATEGORY_GET_SUCCESS,
      payload: data.dish_categories,
    });
  } catch (e) {
    yield put({
      type: types.DISH_CATEGORY_GET_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* createOrUpdate({ payload }) {
  try {
    const currentRestaurant = yield select((s) => s.common.currentRestaurant);
    const api = new DishCategoriesApi(currentRestaurant?.id);
    const { id, formData, history } = payload;
    const response = id
      ? yield api.put(id, { data: formData })
      : yield api.create({
          data: formData,
          headers: { 'Content-Type': 'multipart/Form-data' },
        });
    yield put({
      type: types.DISH_CATEGORY_CREATE_OR_UPDATE_SUCCESS,
    });
    yield put({
      type: types.DISH_CATEGORY_GET_REQUEST,
    });
    UIHelper.showCreateOrUpdateSuccess();
    history?.push(routeCodes.menu);
  } catch (e) {
    yield put({
      type: types.DISH_CATEGORY_CREATE_OR_UPDATE_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* deleteDishCategory({ payload }) {
  try {
    const currentRestaurant = yield select((s) => s.common.currentRestaurant);
    const api = new DishCategoriesApi(currentRestaurant?.id);
    const { history, id } = payload;

    yield api.destroy(id);
    yield put({
      type: DISH_CATEGORY_GET_REQUEST,
    });
    yield put(
      setModalData({
        open: false,
        variant: 'primary',
        title: '',
        body: '',
        itemData: {},
      }),
    );
    history?.push(routeCodes.menu);
    yield put({
      type: types.DISH_CATEGORY_DELETE_SUCCESS,
    });
  } catch (e) {
    yield put({
      type: types.DISH_CATEGORY_DELETE_FAILURE,
    });
  }
}

function* changeDishCategoryPosition({ payload }) {
  try {
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new DishCategoriesApi(currentRestaurant?.id);
    yield put({
      type: types.DISH_CATEGORY_CHANGE_POSITION_SUCCESS,
      payload: payload,
    });
    yield api.put(payload.id, { data: {
      position: payload.position + 1,
    } });
  } catch (e) {
    yield put({
      type: types.DISH_CATEGORY_CHANGE_POSITION_SUCCESS,
      payload: { originalPosition: payload.position, position: payload.originalPosition },
    });
  }
}

function* watchDishCategoryCreateOrUpdate() {
  yield takeLatest(
    types.DISH_CATEGORY_CREATE_OR_UPDATE_REQUEST,
    createOrUpdate,
  );
}
function* watchGetDishCategories() {
  yield takeLatest(types.DISH_CATEGORY_GET_REQUEST, getDishCategories);
}
function* watchDeleteDishCategories() {
  yield takeLatest(types.DISH_CATEGORY_DELETE_REQUEST, deleteDishCategory);
}

function* watchChangeDishPosition(){
  yield takeLatest(types.DISH_CATEGORY_CHANGE_POSITION_REQUEST, changeDishCategoryPosition);
}

export default function* dishCategoriesSaga() {
  yield all([
    fork(watchDishCategoryCreateOrUpdate),
    fork(watchGetDishCategories),
    fork(watchDeleteDishCategories),
    fork(watchChangeDishPosition),
  ]);
}
